import { EssentialKeyWords } from "../enums";

export const parseDLocalError = (e, fieldName) => {
  if (e.empty) {
    return {
      isRequired: true
    };
  } else if (e.error) {
    return `${fieldName}.defaultError`;
  } else if (fieldName === 'pan' && !e.complete && e.brand === 'default') {
    return `${fieldName}.unknownCard`;
  } else {
    return undefined;
  }
};

export const languageDates = ['pt', 'es'];

export const enableDlocalDisclaimerCountries = ['BR'];

export const isEssentialPlan = (plan) => {
  return EssentialKeyWords.some(keyword => plan?.name?.toLowerCase().includes(keyword)) &&
  plan?.active === true && plan?.hidden === false
}
export const existsAnyEssentialPlan = (plans) => {
  return plans.some(plan => isEssentialPlan(plan));
}